import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {useQuery} from '@tanstack/react-query';
import {useSelector} from 'react-redux';

import {CART_BUTTON} from 'constants/analytics/events/cart';
import {ENDPOINTS} from 'constants/endpoints';
import {useGetCustomerEmail} from 'hooks/getCustomerData/getCustomerData';
import {apiConfig} from 'libs/api/api';
import {flags} from 'libs/rollout';
import {localStore} from 'libs/storage/storage';

import {getCartTotalPrice} from '../../store/selectors';

const SEND_HOOX_OFFER = 'SEND_HOOX_OFFER_KEY';
type HoxDataType = {text: string; description: string; value: string};

const cleanEmail = (email: string): string =>
    email ? email?.replace(/^"|"$/g, '').replace(/''|""/g, '') : '';

const fetchHoxData = async ({
    email,
    transactionAmount,
}: {
    email: string;
    transactionAmount: number;
}): Promise<HoxDataType[] | null> => {
    if (!email || Number(transactionAmount) === 0) {
        return null;
    }

    const {data} = await apiConfig.instanceGusaBackend({
        data: {
            email,
            transactionAmount,
        },
        method: 'post',
        url: ENDPOINTS.HOOX_OFFER,
    });

    if (data.length) {
        const offer = data[0];
        sendDesktopAnalyticsEvent(
            CART_BUTTON,
            {
                action: 'Hoox',
                label: `Offer - ${offer.name}. | .${offer.value}. | .${offer.description}`,
            },
            false,
        );
    } else {
        sendDesktopAnalyticsEvent(
            CART_BUTTON,
            {
                action: 'Hoox',
                label: 'NA',
            },
            false,
        );
    }

    return data;
};

/**
 *  sends a request for hoox offer and receives the offer
 */
export const useHoox = () => {
    const email =
        useGetCustomerEmail() ||
        localStore.get('popUpEmail') ||
        localStore.get('email') ||
        localStore.get('subscriptionEmail') ||
        '';

    const transactionAmount = useSelector(getCartTotalPrice);
    const cleanedEmail = cleanEmail(email);
    const {data} = useQuery({
        enabled: flags.hoox.isEnabled(),
        queryFn: () => fetchHoxData({email: cleanedEmail, transactionAmount}),
        queryKey: [SEND_HOOX_OFFER, transactionAmount, cleanedEmail],
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });

    return {data};
};
